import { inject, Injectable } from '@angular/core';
import { BaseService } from '@services/base-service.service';
import { IProgramTarget, IProgramTargetParams } from '../interfaces/tab-program-target.interface';
import { Observable } from 'rxjs';
import { BaseResponse } from '@shared/base/base-response';
import { API } from '@config/constants/api.constant';

@Injectable()
export class ProgramTargetApiService {
  private readonly baseService = inject(BaseService);

  getProgramTargetList(id: string, params: IProgramTargetParams): Observable<BaseResponse<IProgramTarget[]>> {
    const endpoint = `${API.TARGET_DISTRIBUTOR.MONITORING.TARGET_DISTRIBUTOR_BY_DISTRIBUTOR}${id}`;
    return this.baseService.getData<IProgramTarget[]>(endpoint, { disableModalPopupError: true }, params);
  }
}
